import React from 'react'
import { useMemo } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';
import Select, { components } from 'react-select';
import styled from 'styled-components';
import AdminMaster from '../../../Layout/admin/Master';
import { changeAllTitleFunction } from '../Dashboard/functions';
import { Tooltip } from '@mui/material';
import queueDatatableCustomStyles from '../../../Layout/Elements/QueueDatatableCustomStyles';
import useCommonAlert from '../../../hooks/useCommonAlert';
import CommonSwal from '../../CommonSwal';
import { CREATE_EXCLUDED_PAYER, EDIT_EXCLUDED_PAYER, EXCLUDED_PAYER_LIST } from '../../../routeNames';
import { enableOrDisableExcluded, getExcludedpayerList } from '../../../Redux/Excludedpayer/action';
import { useRowLoaders } from '../../../hooks/dataTableRowLoader';
import PartnerDropDown from '../../common/PartnerClientFacilityDropDown/PartnerDropDown';
import ClientDropDown from '../../common/PartnerClientFacilityDropDown/ClientDropDown';
import FacilityDropDown from '../../common/PartnerClientFacilityDropDown/FacilityDropDown';
import { useFormik } from 'formik';
import useFilter from '../../../hooks/useFilter';
import FilterComponent from '../../common/FilterComponent';
import TableHeadings from '../../common/TableHeadings';
import { useLogModal } from '../../../hooks/useLogModal';
import { getExcludedPayerLogs } from '../../../Redux/sftpClient/action';
import { BsClockHistory } from 'react-icons/bs';
import CustomeLogModal from '../../common/CustomeLogModal';
import { BiHistory } from 'react-icons/bi';

const TextField = styled.input`
    height: 32px;
    width: 200px;
    &:hover {
        cursor: pointer;
    }
    `;
const ClearButton = styled(Button)`
	border-top-left-radius: 0;
	border-bottom-left-radius: 0;
	border-top-right-radius: 5px;
    border-left: 0;
    color: #1ba1a7;
	border-bottom-right-radius: 5px;
	height: 35px;
	width: 32px;
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: center;
    background-color: #f5f8fa;
    border-color: #d9d9d9;
    &:hover {
        background-color: #f5f8fa;
        border-color: #d9d9d9;
        color: #1ba1a7;
    }
    &:focus {
        background-color: #f5f8fa !important;
        border-color: #d9d9d9 !important;
        color: #1ba1a7;
    }
    


`;

const Excludedpayerlist = () => {
    const { setLoading: rowLoader, isRowLoading, clearLoading, loadingRows } = useRowLoaders();
    const { showCustomeSwal, isSwalCommon, hideCustomeSwal } = useCommonAlert()
        const {
        isOpen,
        logData,
        loading:loadingLog,
        totalRows:totalRowsLog,
        limit:limitLog,
        colorRow:colorRowLog,
        openModal,
        closeModal,
        handlePageChange:handlePageChangeLog,
        handlePerRowsChange:handlePerRowsChangeLog,
        handleRowClick:handleRowClickLog,
        handleChangeFilter,
        userSelectlist,
        filterData,
    } = useLogModal(getExcludedPayerLogs);

    const [state, setState] = useState({
        error: false,
        error_message: "",
        showToast: false,
    });
    const [pageno, setPageNo] = useState(1);


    const [toaster, setToaster] = useState(false)

    const [filterText, setFilterText] = useState('');
    const [colorRow, setColorRow] = React.useState({});
    const status_list = [{ value: "true", label: "Active" }, { value: "false", label: "Inactive" }]

    const handleClear = () => {
        if (filterText) {
            //setResetPaginationToggle(!resetPaginationToggle);
            setFilterText('');
            fetchExcludedpayer(1, limit)
        }
    };

    const initialFilters = {
        clients: [],
        facility: [],
        partner: [],
        is_active: ""
    };
    console.log(initialFilters, "initialFiltersinitialFiltersinitialFilters");
    const [columnState,setColumnState] =  useState({
       
        client:true,
        facility:true,
        partner:true,
        payer:true,
        actions:true,
    })
    // Use the custom hook
    const {
        data,
        setData,
        loading,
        pageNo,
        limit,
        totalRows,
        reRenderDataTable,
        searchFormik,
        handlePageChange,
        handlePerRowsChange,
        handleReset,
        fetchData: fetchExcludedpayer
    } = useFilter(initialFilters, getExcludedpayerList);

    useEffect(() => {
        fetchExcludedpayer(1, limit)
    }, []);

    // const handlePageChange = page => {
    //     setPageNo(page)
    //     fetchExcludedpayer(page, limit, filterText);
    // };
    // const showTooltip = (text, props) => (
    //     <Tooltip id="button-tooltip" {...props}>
    //         {text}
    //     </Tooltip>
    // );
    // const toggleTooltip = (props) => (
    //     <Tooltip id="button-tooltip" {...props}>
    //         Status
    //     </Tooltip>
    // );

    // const handlePerRowsChange = async (newPerPage, page) => {
    //     setLoading(true);
    //     fetchExcludedpayer(1, newPerPage, filterText)
    //     setPageNo(1)
    //     setLimit(newPerPage)
    //     setLoading(false);
    //     handleResetDataTable()
    // };


 const __toggleNpiTin = (id) => {
    rowLoader(id);
    enableOrDisableExcluded(id)((response) => {
        if (response?.status && response?.status_code === 200) {
            setState({ showToast: !state.showToast });

            setData(prevData => ({
                ...prevData,
                results: Array.isArray(prevData.results)
                    ? prevData.results.map(item =>
                        item?.id === id
                            ? { ...item, is_active: !item.is_active }
                            : item
                    )
                    : []
            }));

            setToaster('success');
            clearLoading(id);
        } else {
            clearLoading(id);
            showCustomeSwal({
                row: null,
                show: true,
                title: "Error",
                type: 'error',
                message: response?.response?.data?.message,
                onConfirm: () => {
                    hideCustomeSwal();
                },
                confirmBtnText: "Ok",
                showCancel: false,
                showConfirm: true,
            });
            setState({ error: true, error_message: response?.message });
        }
    });
};




    useEffect(() => {
        if (toaster) {
            const timer = setTimeout(() => {
                setToaster(false)
            }, 2000);
            return () => clearTimeout(timer)
        }
    }, [toaster])

    const handleSearchSplits = async (e) => {
        setFilterText(e)
        let data = e ? e : '';
        fetchExcludedpayer(1, limit, data)
        handleResetDataTable()
        //setResetPaginationToggle(!resetPaginationToggle)
    }

    const handleRowClick = (row) => {
        setColorRow(row);
    };

    const handleRowCheckClick = (row) => {
        data?.results.map((item, index) => {
            if (row?.id == item.id) {
                setColorRow(row)
            }
        })
    };

    // const Searchformik = useFormik({
    //     enableReinitialize: true,
    //     initialValues: {
    //         partner: "",
    //         clients: "",
    //         facility: "",
    //     },

    //     onSubmit: (values) => {

    //       fetchExcludedpayer(pageno, limit, values?.partner,values?.clients,values?.facility)
    //     },

    // });

    const checkUserPermission = (check) => {
        var permissions = JSON.parse(localStorage.getItem('permissions'))
        var data = permissions.find((element) => {
            return element == check;
        })
        if (data && data != undefined) {
            return true;
        }
        else {

            return false;
        }
    }
    var i = 0;
    const conditionalRowStyles = [

        {
            when: row => { i = i + 1; return i % 2 == 0 || colorRow.id == row.id ? true : false },
            style: (row, index) => ({
                backgroundColor: colorRow?.id == row.id ? '#dbf4f5' : '#f2f2f2',
            }),
        },
    ];


    const columns = useMemo(
        () => [
            {
                id: 'id',
                name: 'S.NO',
                selector: (row, index) => pageno == 1 ? index + 1 : (pageno - 1) * limit + index + 1,
                sortable: true,
                width: '50px',
                //sortable: true,

            },
            {
                id: 'client',
                name: 'client',
                selector: row => row?.client,
                cell: (row) => <div>
                    {row?.client &&

                        <div className='d-flex flex-row  flex-wrap text-truncate me-2' style={{ width: "220px" }} onClick={() => handleRowClick(row)} >
                            <Tooltip disableInteractive title={row?.client} placement='top' arrow>
                                {row?.client &&
                                    <span className='text-truncate ' onDoubleClick={() => handleDblClickCopy(row?.client)}>{row?.client}</span>
                                }
                            </Tooltip>
                        </div>
                    }
                </div>,
                // width:"250PX",
                sortable: true,
                omit:!columnState?.client
            },
            

            {
                id: 'facility',
                name: 'Facility',
                // width: "250px",
                selector: row => row?.facility,
                cell: (row) => <div>
                    {row?.facility &&
                        <div className='d-flex flex-row flex-wrap text-truncate' style={{ width: "220px" }} onClick={() => handleRowClick(row)} >
                            <Tooltip disableInteractive title={row?.facility} placement='top' arrow>
                                {row?.facility &&
                                    <span className='text-truncate' >{row?.facility}</span>
                                }
                            </Tooltip>
                        </div>

                    }

                </div>,
                sortable: true,
                omit:! columnState?.facility,
            },
            {
                id: 'partner',
                name: 'partner',
                // width: "250px",

                selector: row => row?.partner,
                cell: (row) => <div>
                    {row?.partner &&
                        <div className='d-flex flex-row flex-wrap text-truncate' style={{ width: "220px" }} onClick={() => handleRowClick(row)} >
                            <Tooltip disableInteractive title={row?.partner} placement='top' arrow>
                                {row?.partner &&
                                    <span className='text-truncate' >{row?.partner}</span>
                                }
                            </Tooltip>
                        </div>

                    }

                </div>,
                sortable: true,
                omit:! columnState?.partner,
            },
            {
                id: 'payer',
                name: 'payer',
                minWidth:'400px',
                selector: row => row?.payer,
                cell: (row) => <div>
                    {row?.payer &&
                        <div className='d-flex flex-row flex-wrap text-truncate' style={{ width: "370px" }} onClick={() => handleRowClick(row)} >
                            <Tooltip disableInteractive title={row?.payer} placement='top' arrow>
                                {row?.payer &&
                                    <span className='text-truncate' >{row?.payer}</span>
                                }
                            </Tooltip>
                        </div>
                    }
                </div>,
                sortable: true,
                omit:! columnState?.payer,
            },

            {
                id: 'actions',
                name: 'Actions',
                cell: (row) =>
                    <div className='d-flex align-items-center gap-2' onClick={() => handleRowClick(row)}>
                        <React.Fragment>
                            {checkUserPermission('edit_excluded_payer') &&

                                <Tooltip disableInteractive title="Edit" placement='top' arrow>
                                    <Link onClick={() => changeAllTitleFunction('Edit Excluded Payer', `${EDIT_EXCLUDED_PAYER}${row.id}`)} className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm p-1 me-1" >
                                        <span className="svg-icon svg-icon-3">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path opacity="0.3" d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z" fill="currentColor"></path>
                                                <path d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z" fill="currentColor"></path>
                                            </svg>
                                        </span>
                                    </Link>
                                </Tooltip>
                            }
                            {checkUserPermission('enable_excluded_payer') &&

                                !isRowLoading(row.id) ?
                                <div className="ms-2" >
                                    <Tooltip disableInteractive title="Status" placement='top' arrow>
                                        <Form.Check
                                            onClick={() => __toggleNpiTin(row.id)}
                                            type="switch"
                                            role="switch" defaultChecked={row.is_active} id="flexSwitchCheckDefault"
                                        />
                                    </Tooltip>
                                </div>
                                :
                                <div className="me-2" >
                                    <div className="spinner-border spinner-border-sm " role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>

                            }
                            <Tooltip disableInteractive title="Excluded Payer Logs" placement="top" arrow>
                                <Link
                                    className="d-flex align-items-center"
                                    style={{ fontSize: '1.5em', height: '32px' }}
                                    onClick={() => openModal(row?.id)}
                                >
                                    <BiHistory className='icon-style' />
                                </Link>
                            </Tooltip>
                        </React.Fragment>

                    </div>,
                //sortable: true,
                ignoreRowClick: false,
                allowOverflow: true,
                 right: true,
                button: false,
                // width: "100px",
                omit:! columnState?.actions,

            },



        ],
        [pageno, loadingRows, data,columnState],
    );

    const handleResetDataTable = () => {
        setRerenderDataTable(true)
        setTimeout(() => {
            setRerenderDataTable(false)
        }, 200);
    }

    console.log(data, "dddddddddd")

    return (
        <React.Fragment>
            <AdminMaster ToastMessage={toaster} />
            <main id="main" className="main">
                <CommonSwal
                    isSwalCommon={isSwalCommon}
                />
                <div className="pagetitle tab-fixed-header">
                    <h1 id='page-title'>Excluded Payer</h1>
                </div>

                <section className="section mt-5 ">
                    <div className="row align-items-top py-2 gap-2 gap-md-5">
                        <div className="">
                            <div className="card mb-5 mb-xl-8 ">
                                <div className='card-header pt-3 px-4'>
                                    <FilterComponent
                                        formik={searchFormik}
                                        onReset={handleReset}
                                        extraAction = {
                                        <TableHeadings 
                                        columnState = {columnState}
                                        setColumnState = {setColumnState}
                                        />}
                                    >
                                        {/* Your specific filter fields */}
                                        <PartnerDropDown lockboxformik={searchFormik} />
                                        <ClientDropDown lockboxformik={searchFormik} />
                                        <FacilityDropDown lockboxformik={searchFormik} />
                                        <div style={{width :'250px'}}>
                                            <Select
                                                options={status_list}
                                                className="select-search-client"
                                                classNamePrefix="select"
                                                placeholder="Select Status"
                                                menuPlacement="auto"
                                                maxMenuHeight={300}
                                                isClearable
                                                name="is_active"
                                                value={status_list.filter(i=>i?.value===searchFormik?.values?.is_active)}
                                                onChange={(e) => { searchFormik.setFieldValue("is_active", e?.value || "") }}
                                                styles={{
                                                    control: styles => ({ ...styles, backgroundColor: "hsl(204deg 33.33% 97.06%)", borderStyle: "none", boxShadow: "none", borderRadius: "10px" }), placeholder: styles => ({
                                                        ...styles,
                                                    }), indicatorSeparator: styles => ({ ...styles, width: "0px", minHeight: "20px" }), container: styles => ({ ...styles, borderRadius: "9px" })
                                                }}
                                            />
                                        </div>
                                    </FilterComponent>
                                    
                                 
                                </div>

                                <div className="card-body">
                                    <div className="table-responsive">
                                        <div className="dashboardtable">
                                            {!reRenderDataTable &&
                                                <DataTable
                                                    className="custom-datatable"
                                                    fixedHeader={true}
                                                    data={data?.results}
                                                    columns={columns}
                                                    progressPending={loading}
                                                    pagination
                                                    paginationServer
                                                    highlightOnHover
                                                    paginationTotalRows={totalRows}
                                                    paginationPerPage={limit}
                                                    paginationRowsPerPageOptions={[25, 50, 100]}
                                                    onChangeRowsPerPage={handlePerRowsChange}
                                                    onChangePage={handlePageChange}
                                                    conditionalRowStyles={conditionalRowStyles}
                                                    onRowClicked={handleRowCheckClick}
                                                    theme="solarized"
                                                    customStyles={queueDatatableCustomStyles}

                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <CustomeLogModal
                filterData={filterData}
                userSelectlist={userSelectlist}
                handleChangeFilter={handleChangeFilter}
                show={isOpen}
                onClose={closeModal}
                logData={logData}
                loading={loadingLog}
                totalRows={totalRowsLog}
                limit={limitLog}
                onPageChange={handlePageChangeLog}
                onRowsPerPageChange={handlePerRowsChangeLog}
                onRowClick={handleRowClickLog}
                colorRow={colorRowLog}
                title="Excluded Payer Logs"
            />
        </React.Fragment>
    )
}

export default Excludedpayerlist